module.exports = __webpack_public_path__ + "img/iconList.bc5d3e78.png";